<template>
        <div id='intro'>
              <NavTop title="蓉畅生物科技-品牌介绍" />
              <div class='maincon'>
                      <div id='topcon'>
                        <video class="video" controls :poster="poster" preload="none">
                           <source :src="url" type="video/mp4">
                         </video>
                      </div>
                      <div class='menu'>
                        <van-tabs v-model="tagSelected" scrollspy sticky offset-top="46" color="#000">
                            <van-tab  name="part1">
                              <template #title>
                                <div :class="tagSelected=='part1'?'menu-bg menu-bg-selected':'menu-bg'">
                                  <span :class="tagSelected=='part1'?'menu-txt menu-txt-selected':'menu-txt'">品牌介绍</span>
                                </div>  
                              </template>
                              <img :src="brandImg" />
                            </van-tab>
                            <van-tab  name="part2">
                              <template #title>
                                <div :class="tagSelected=='part2'?'menu-bg menu-bg-selected':'menu-bg'">
                                  <span :class="tagSelected=='part2'?'menu-txt menu-txt-selected':'menu-txt'">公司介绍</span>
                                </div>  
                              </template>
                              <video class="video" controls :poster="poster_corp" preload="none">
                                <source :src="video_corp" type="video/mp4">
                              </video>
                              <img :src="corpImg" />
                            </van-tab>
                            <van-tab  name="part3">
                              <template #title>
                                <div :class="tagSelected=='part3'?'menu-bg menu-bg-selected':'menu-bg'">
                                  <span :class="tagSelected=='part3'?'menu-txt menu-txt-selected':'menu-txt'">冠军代言</span>
                                </div>  
                              </template>
                              <img :src="champImg" />
                              <video class="video_sp1" controls :poster="poster_champ1" preload="none">
                                <source :src="video_champ1" type="video/mp4">
                              </video>
                              <video class="video_sp1" controls :poster="poster_champ2" preload="none">
                                <source :src="video_champ2" type="video/mp4">
                              </video>
                              <video class="video_sp1" controls :poster="poster_champ3" preload="none">
                                <source :src="video_champ3" type="video/mp4">
                              </video>
                            </van-tab>
                            <van-tab  name="part4">
                              <template #title>
                                <div :class="tagSelected=='part4'?'menu-bg menu-bg-selected':'menu-bg noborder'">
                                  <span :class="tagSelected=='part4'?'menu-txt menu-txt-selected':'menu-txt'">检测认证</span>
                                </div>  
                              </template>
                              <video class="video" controls :poster="poster_jc" preload="none">
                                <source :src="video_jc" type="video/mp4">
                              </video>
                              <img :src="jcImg1" />
                              <img :src="jcImg2" />
                              <img :src="jcImg3" />
                            </van-tab>
                         </van-tabs>
                      </div>
              </div> 
        </div>
</template>
<script>
import { Tab, Tabs } from 'vant'
import NavTop from '@/components/navtop'

import brand_img from '@/assets/img/intro/brand.jpg'
import champ_img from '@/assets/img/intro/champ.jpg'
import corp_img from '@/assets/img/intro/corp.jpg'

import jc1_img from '@/assets/img/intro/image1_jc.jpg'
import jc2_img from '@/assets/img/intro/image2_jc.jpg'
import jc3_img from '@/assets/img/intro/image3_jc.jpg'

export default {
  data(){
    return{
      url: 'http://www.cnihz.cn/static/video/index.mp4',
      poster: 'http://www.cnihz.cn/static/video/index_poster.jpg',
      video_corp:'http://www.cnihz.cn/static/video/corp.mp4',
      poster_corp:'http://www.cnihz.cn/static/video/corp_poster.jpg',
      video_champ1:'http://www.cnihz.cn/static/video/champ1.mp4',
      poster_champ1:'http://www.cnihz.cn/static/video/champ1_poster.jpg',
      video_champ2:'http://www.cnihz.cn/static/video/champ2.mp4',
      poster_champ2:'http://www.cnihz.cn/static/video/champ2_poster.jpg',
      video_champ3:'http://www.cnihz.cn/static/video/champ3.mp4',
      poster_champ3:'http://www.cnihz.cn/static/video/champ3_poster.jpg',

      video_jc:'http://www.cnihz.cn/static/video/video_jc.mp4',
      poster_jc:'http://www.cnihz.cn/static/video/poster_jc.jpg',

      brandImg:brand_img,
      champImg:champ_img,
      corpImg:corp_img,

      jcImg1:jc1_img,
      jcImg2:jc2_img,
      jcImg3:jc3_img,

      tagSelected:''
    }
  },
  name: 'intro',
  methods:{
    togglePart(selectedTag){
       this.tagSelected=selectedTag
    }
  },
  components:{
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      NavTop
     }
}
</script>
<style scoped>
#intro{background-color:#F6F6F6;width:100%;height:100%;}
.scroll-view{height:100%;}
.sticky{display: flex; flex-flow: row nowrap;align-items: center;}
.sticky-block{width:25%;height:30px;background-color: #F6F6F6;display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;}
.sticky-txt{font-size:14px;color:#333;}

.b-right{border-right:1px solid #A8A8B4;}
.part{background: #fff;}

.sticky-block-selected{width:25%;height:50px;background-color: #000000;display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;}
.sticky-txt-selected{font-size:16px;color:#fff;}

.topcon{height:200px;width:100%;}
.video {width: 100%;height: 200px;background-color: #000;}
.video_sp1{width:100%;height: 690px;background-color: #000;}


.menu{background-color: #fff;}
.menu-bg{width:100%!important;height:100%!important;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;background-color: #f2f2f2;border-right:1px solid #A8A8B4}
.menu-bg-selected{background-color: #000;border-right:none;}
.menu-txt{color:#000;}
.menu-txt-selected{color:#fff;}
.noborder{border-right: none!important;}

::v-deep .van-tab{width:100%;height:100%;padding: 0!important;}
::v-deep .van-tab__text--ellipsis{width:100%;height:100%;}
::v-deep .van-tabs__line{transform:none!important;transition-duration:0s!important;display: none!important;}
</style>


